import deburr from "lodash.deburr";

/**
 * Supabase Storage validates object keys server-side and answers `400 Invalid key` for anything
 * outside its allowed character set. Deburring plus the space/hyphen/tilde swaps left plenty of
 * ordinary filenames through untouched — `Booking_#5363583533_receipt.pdf` straight off a bank or
 * booking confirmation was rejected on upload, as was anything with `%`, `[`, `]`, `"` or a script
 * `deburr` cannot fold to ASCII (Cyrillic, CJK, emoji).
 *
 * Rather than mirroring Supabase's permissive regex — which would silently drift from theirs — this
 * keeps only characters that are unambiguously safe in a key, so the result is always accepted.
 */
const ALLOWED_CHARACTERS = /[^A-Za-z0-9._]/g;

export const normalizeFileName = (name: string) => {
  const normalized = deburr(name.replaceAll(" ", "_").replaceAll("-", "_"))
    .replaceAll("~", "_")
    .replace(ALLOWED_CHARACTERS, "_")
    .replace(/_{2,}/g, "_");

  // A name made up entirely of unsupported characters collapses to a bare separator, and an empty
  // path segment is itself an invalid key.
  return /[A-Za-z0-9]/.test(normalized) ? normalized : "file";
};
